import { gql } from "@apollo/client";

export const CREATE_EVENT = gql`
mutation createEvent($input: eventInput!) {
  createEvent(input: $input)
}
`;

export const GET_ALL_CALENDAR = gql`
query getAllEvents($input: getCalendarInput!) {
  getAllEvents(input: $input) {
    nodes {
      eId
      eIsPublish
      eTitle
      eOriginalTitle
      eDescription
      eDate
      favouritesByEId
      feedsByEId
    }
    totalCount
  }
}
`;

export const UPDATE_EVENT_STATUS = gql`
mutation updateEventStatus($input: updateEventStatusInput!) {
  updateEventStatus(input: $input)
}
`;

export const DELETE_EVENT = gql`
mutation deleteEvent($eId: String!) {
  deleteEvent(eId: $eId)
}
`;

export const UPDATE_EVENT = gql`
mutation updateEvent($eId: String!, $input: eventInput!) {
  updateEvent(eId: $eId, input: $input)
}
`;

export const ADD_FAVOURITE = gql`
mutation addFavourite($eId: String!) {
  addFavourite(eId: $eId)
}`;

export const REMOVE_FAVOURITE = gql`
mutation deleteFavouriteByFaId($faId: UUID!) {
  deleteFavouriteByFaId(input: {faId: $faId}) {
    clientMutationId
  }
}`;